import Vue from "vue";
import App from "./App.vue";
import "@/service/axios";
import "./style.css";
import Vuelidate from "vuelidate";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "./service/alert";

// Import Bootstrap and BootstrapVue CSS files (order is important)
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import Router from "vue-router";
import TicketForm from "@/page/detail.vue";
import Conversation from "@/page/conversation.vue";
import NotAllowed from "@/page/notAllowed.vue";
import Home from "@/page/index.vue";
import VueMoment from "vue-moment";
import "./service/icon.js";
const moment = require("moment");
Vue.use(Router);
Vue.config.productionTip = false;
Vue.use(Vuelidate);
Vue.use(BootstrapVue);
Vue.use(VueMoment, {
  moment,
});
var url =
  window.location != window.parent.location
    ? document.referrer
    : document.location.href;

Vue.prototype.$bus = new Vue();
Vue.prototype.$parentOrigin = url;
const router = new Router({
  mode: "history",
  linkActiveClass: "active",
  linkExactActiveClass: "exact-active",
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    { path: "/", redirect: "/ticket" },
    { path: "/ticket", component: Home },
    { path: "/ticket/:ticketId", component: TicketForm },
    {
      path: "/user/:userGuid/conversation/:conversationId",
      name: "conversation-detail",
      component: Conversation,
    },
    {
      path: "/not-allowed",
      component: NotAllowed,
      name: "not-allowed",
    },
    // { path: "/about", component: AboutView },
  ],
});

router.beforeEach((to, from, next) => {
  const host = window.location.hostname;

  if (to.name === "conversation-detail") {
    const { userGuid, conversationId } = to.params;
    const { brand_code } = to.query;

    const allowedDomain = "crm-ticket-thread.dosetech.co";
    if (host !== allowedDomain) {
      return next({ name: "not-allowed" });
    }

    if (!userGuid || !conversationId || !brand_code) {
      return next({ name: "not-allowed" });
    }
  }
  next();
});
new Vue({ router, render: (h) => h(App) }).$mount("#app");
